var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 7.70001C17.9927 7.41817 18.3497 7.21193 18.7401 7.09913C19.1304 6.98634 19.5424 6.9704 19.9403 7.05269C20.3383 7.13498 20.7101 7.31303 21.0237 7.57141C21.3373 7.82979 21.5832 8.16072 21.7401 8.53554C21.897 8.91036 21.9602 9.31778 21.9242 9.72252C21.8882 10.1273 21.754 10.5171 21.5334 10.8583C21.3128 11.1996 21.0123 11.4819 20.658 11.6808C20.3037 11.8797 19.9062 11.9893 19.5 12H2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 4.59999C9.83168 4.36369 10.1184 4.18858 10.4344 4.09034C10.7504 3.9921 11.0858 3.97381 11.4106 4.03711C11.7355 4.10041 12.0395 4.24332 12.2955 4.45303C12.5515 4.66273 12.7514 4.93268 12.8774 5.23868C13.0034 5.54468 13.0515 5.87716 13.0174 6.20633C12.9833 6.53549 12.8681 6.85104 12.682 7.12471C12.4959 7.39837 12.2449 7.62158 11.9513 7.77434C11.6578 7.9271 11.3309 8.00463 11 7.99999H2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 19.4C12.8317 19.6363 13.1184 19.8114 13.4344 19.9097C13.7504 20.0079 14.0858 20.0262 14.4106 19.9629C14.7355 19.8996 15.0395 19.7567 15.2955 19.547C15.5515 19.3373 15.7514 19.0673 15.8774 18.7613C16.0034 18.4553 16.0515 18.1228 16.0174 17.7937C15.9833 17.4645 15.8681 17.149 15.682 16.8753C15.4959 16.6016 15.2449 16.3784 14.9513 16.2257C14.6578 16.0729 14.3309 15.9954 14 16H2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.5ab4ecbcc22655233a7f75aa47645306.svg";
export { ForwardRef as ReactComponent };